import { useRef } from 'react';

import { type EndStateConfig, ExperiencePerformanceTypes, ExperienceTypes } from '../core';
import { StreamingUFOExperience } from '../core/experience/StreamingUFOExperience';

export const useUFOStreamingExperience = (
	id: string,
	component: string,
): {
	abort: (config?: EndStateConfig) => void;
	failure: (config?: EndStateConfig) => void;
	reportRTT: (chunkIndex: number) => void;
	reportTTFB: () => void;
	start: () => void;
	startConnectionAttempt: () => void;
	success: (config?: EndStateConfig) => void;
	successConnectionEstablished: () => void;
} => {
	const ref = useRef<StreamingUFOExperience>(
		new StreamingUFOExperience(id, {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
			platform: { component },
		}),
	);

	const start = (): void => {
		ref.current.start();
	};

	const success = (config?: EndStateConfig): void => {
		ref.current.success(config);
	};

	const failure = (config?: EndStateConfig): void => {
		ref.current.failure(config);
	};

	const abort = (config?: EndStateConfig): void => {
		ref.current.abort(config);
	};

	const startConnectionAttempt = (): void => {
		ref.current.startConnectionAttempt();
	};

	const successConnectionEstablished = (): void => {
		ref.current.connectionEstablished();
	};

	const reportTTFB = (): void => {
		ref.current.reportTTFB();
	};

	const reportRTT = (chunkIndex: number): void => {
		ref.current.reportRTT(chunkIndex);
	};

	return {
		startConnectionAttempt,
		successConnectionEstablished,
		reportTTFB,
		reportRTT,
		start,
		success,
		failure,
		abort,
	};
};
